// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pagination[data-v-c3c3ee3e] {\r\n  padding-top: 18px;\r\n  text-align: right;\n}\r\n", ""]);
// Exports
module.exports = exports;
